import React, {useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {toggleLoader} from "../../../store/global/global-slice";
import {PublisherService} from "../../../services/publisher.service";
import Grid from "@material-ui/core/Grid";
import {StyledButton} from "../../../components/ui-base/button";
import {useTranslation} from "react-i18next";
import {PublisherMyBookList} from "../../../components/publisher/my-books/my-book-list";
import {useHistory} from "react-router-dom";
import {
	ElasticFilterType,
	ElasticSearchSort,
	ElasticSearchType,
	SearchFilters,
	SearchForElastic
} from "../../../components/publisher/books/search-for-elastic";
import {LastElasticSearchDataModel} from "../../../models/view/last-elastic-search-data.model";
import {PaginationElasticSearchModel} from "../../../models/pagination-elastic-search.model";
import {PublisherBookModel} from "../../../models/publisher/publisher-book.model";

const PublisherMyBooksListPage = () => {
	const [books, setBooks] = useState<PaginationElasticSearchModel<PublisherBookModel[]>>()
	const [lastSearchData, setLastSearchData] = useState<LastElasticSearchDataModel>({searchType: ElasticSearchType.searchTypeTitle, searchValue: '', sortField: ElasticSearchSort.created, sortValue: 'desc', filters: {} as SearchFilters});
	const dispatch = useDispatch();
	const history = useHistory();
	const { t } = useTranslation('common');

	const loadBooks = useCallback(async (
		sortField: ElasticSearchSort,
		sortValue: 'asc'|'desc',
		searchType: ElasticSearchType,
		searchValue: string,
		filters: SearchFilters,
		page: number = 1,
		perPage: number = 12
	) => {
		dispatch(toggleLoader(true));
		const res = await PublisherService.getAllMyBooksSearch(sortField, sortValue, searchType, searchValue, filters, page, perPage);

		if (page === 1) {
			setBooks(res);
		} else {
			setBooks((old) => {
				return {
					...res,
					results: [...old.results, ...res.results]
				}
			});
		}

		dispatch(toggleLoader(false));
	}, [dispatch]);

	const loadNextBooks = () => {
		loadBooks(
			lastSearchData.sortField,
			lastSearchData.sortValue,
			lastSearchData.searchType,
			lastSearchData.searchValue,
			lastSearchData.filters,
			books.next,
			12
		);
	}

	const loadData = (
		sortField: ElasticSearchSort,
		sortValue: 'asc'|'desc',
		searchType: ElasticSearchType,
		searchValue: string,
		filters: SearchFilters
	) => {
		setLastSearchData({
			sortValue: sortValue,
			sortField: sortField,
			searchType: searchType,
			searchValue: searchValue,
			filters: filters
		});

		loadBooks(
			sortField,
			sortValue,
			searchType,
			searchValue,
			filters,
			1,
			12
		);
	}

	useEffect(() => {
		loadBooks(
			lastSearchData.sortField,
			lastSearchData.sortValue,
			lastSearchData.searchType,
			lastSearchData.searchValue,
			lastSearchData.filters
		);
	}, [loadBooks]);

	return (
		<Grid item container direction={"column"}>
			<Grid item style={{ marginBottom: '20px'}}>
				<p>{t('navbar.myBooksNotice')}</p>
			</Grid>
			<Grid item container direction={"row"} justifyContent={'space-between'}>
				<Grid item>
					<SearchForElastic
						loadData={loadData}
						searchTypeOptions={[ElasticSearchType.searchTypeTitle, ElasticSearchType.searchTypeAuthor]}
						sortTypeOptions={[ElasticSearchSort.created]}
						showSort={false}
						showFilter={true}
						filterOptions={[ElasticFilterType.bookPhases]}
					/>
				</Grid>
				<Grid item>
					<StyledButton type={"button"} style={{marginRight: '1rem'}} onClick={() => {
						history.push('/publisher/my-books/create');
					}}>
						{t('navbar.myBookCreate')}
					</StyledButton>
				</Grid>
			</Grid>
			<Grid item container direction={"row"} spacing={2}>
				{books?.results.map((book) => (
					<PublisherMyBookList key={book.id} book={book}/>
				))}
			</Grid>

			{books?.next &&
                <Grid container direction={"row"} justifyContent={"center"} style={{marginTop: '30px'}}>
                    <StyledButton type={"button"} color={"transparent"} onClick={() => {
						loadNextBooks();
					}}>
						{t('loadNext')}
                    </StyledButton>
                </Grid>
			}
		</Grid>
	)
}

export default PublisherMyBooksListPage;
